// api/photos.js
import { url } from './config';

// export const fetchPhotos = async () => {

//     const res = await fetch(`${url}/api/photos`);
//     if (!res.ok) throw new Error("Ошибка загрузки фотографий");
//     return await res.json(); // массив путей к изображениям
// };

export const fetchPhotos = async () => {
    console.log("Запрос на получение списка фотографий...");

    try {
        const res = await fetch(`${url}/api/photos`);
        console.log("Ответ получен:", res);

        if (!res.ok) {
            console.error("Ошибка ответа от сервера:", res.status, res.statusText);
            throw new Error("Ошибка загрузки фотографий");
        }

        const data = await res.json();
        console.log("Список фотографий:", data);

        return data;
    } catch (err) {
        console.error("Ошибка при запросе фотографий:", err);
        throw err;
    }
};

